export enum ExamQuestionWeightingType {
    None = -1,
    Difficulty = 0,
    Topic = 1
}